module.exports = __webpack_public_path__ + "img/ic_nodocumentsuploaded.f04fb369.svg";